import axios from 'axios';

import {ActionType} from '../actionTypes';

import envManager from '../../com/envManager/EnvManager';

import {
    Action as FlyersActions,
    Action as HardDeleteFlyerStartAction,
    Action as SoftDeleteFlyerStartAction,
    Action as ClearDataForFlyer
} from '../actions/flyersActions';

import {Action as SaleTypesActions} from "../actions/saleTypeActions";
import {Action as SellingUnitsActions} from "../actions/sellingUnitsActions";
import {Action as ShelvesStylesForStoreActions} from "../actions/storeShelfStylesActions";
import {Action as CheckoutUrlSettingActions} from "../actions/flyerConversionSettingsActions";
import {Action as AccountSettingsWithLangActions} from "../actions/accountSettingsAndLangActions";

import {Dispatch} from 'redux';
import {ErrorDtoFactory, SaleTypeDto, UpdateSaleTypesObjectDto, UserDto} from '../../dtos';
import {FlyersState} from "../reducers/flyersReducer";

export const getFlyers = (isArchived: boolean, isSoftDeleted: boolean) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }

    return async (dispatch: Dispatch<FlyersActions | SaleTypesActions | CheckoutUrlSettingActions | SellingUnitsActions | AccountSettingsWithLangActions | ShelvesStylesForStoreActions>) => {
        dispatch({
            type: ActionType.GET_FLYERS_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let request: {};

            if (isArchived) {
                request = {
                    "isArchived": isArchived,
                }
            } else if (isSoftDeleted) {
                request = {
                    "isSoftDeleted": isSoftDeleted
                }
            } else {
                request = {
                    "isArchived": isArchived,
                    "isSoftDeleted": isSoftDeleted
                }
            }


            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/flyers/${userDto.userId}/GetFlyersFiltered`, request, config);
            let data = result.data.data

            dispatch({
                type: ActionType.GET_FLYERS_SUCCESS,
                payload: data
            })

            dispatch({
                type: ActionType.SET_SALE_TYPES_FOR_ALL_FLYERS,
                payload: data.saleTypes
            })

            dispatch({
                type: ActionType.SET_SALE_UNITS_FOR_ALL_FLYERS,
                payload: data.sellingUnits
            })
            dispatch({
                type: ActionType.SET_STORE_SHELF_STYLES,
                payload: data.storeShelfStyles
                // payload: [...data.storeShelfStyles, {
                //     accountId: null,
                //     caption: "Default",
                //     colorRgb: "#aabb00",
                //     id: 1,
                //     textureImage: "Dummy.png",
                //     textureImageUrl: null
                // }]
            })
            dispatch({
                type: ActionType.SET_ACCOUNT_SETTING_SUCCESS,
                payload: {
                    accountSetting: data.accountSetting,
                    languageId: data.languageId
                }
            })
            dispatch({
                type: ActionType.SET_ACCOUNT_SETTING_COMPLETE,
            })

            dispatch({
                type: ActionType.GET_FLYERS_COMPLETED,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.GET_FLYERS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const softDeleteFlyer = (flyersIds: number[], lang: string, isSoftDelete: boolean, flyersState: FlyersState) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<SoftDeleteFlyerStartAction | FlyersActions>) => {
        dispatch({
            type: ActionType.SOFT_DELETE_FLYER
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token,
                    'XC-ConnectionId': '1'
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyers': flyersIds,
                'uiLanguageCultureCode': lang,
                'flyerSoftDeleteState': isSoftDelete
            };
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/SetFlyersSoftDeleteState`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.SOFT_DELETE_FLYER_SUCCESS,
                payload: data
            })
            const newFlayerState = flyersState.flyers.filter(key => {
                let isExist = flyersIds.some(id => key.flyRecId === id);
                if (!isExist) {
                    return key;
                }
            })

            const flyersStatePayload: FlyersState = {...flyersState, flyers: [...newFlayerState]}
            dispatch({type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})

        } catch (err) {
            dispatch({
                type: ActionType.SOFT_DELETE_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const hardDeleteFlyer = (flyersIds: number[], flyersState: FlyersState) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<HardDeleteFlyerStartAction>) => {
        dispatch({
            type: ActionType.HARD_DELETE_FLYER
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyers': flyersIds
            };
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/HardDeleteFlyers`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.HARD_DELETE_FLYER_SUCCESS,
                payload: data
            })

            const newFlayerState = flyersState.flyers.filter(key => {
                let isExist = flyersIds.some(id => key.flyRecId === id);
                if (!isExist) {
                    return key;
                }
            })

            const flyersStatePayload: FlyersState = {...flyersState, flyers: [...newFlayerState]}
            dispatch({type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})

        } catch (err) {
            dispatch({
                type: ActionType.HARD_DELETE_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const archiveFlyer = (flyersIds: number[], lang: string, isArchive: boolean, flyersState: FlyersState) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<HardDeleteFlyerStartAction | FlyersActions>) => {
        dispatch({
            type: ActionType.ARCHIVE_FLYER
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyers': flyersIds,
                'uiLanguageCultureCode': lang,
                'flyerArchiveState': isArchive
            };
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/SetFlyersArchiveState`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.ARCHIVE_FLYER_SUCCESS,
                payload: data
            })
            const newFlayerState = flyersState.flyers.filter(key => {
                let isExist = flyersIds.some(id => key.flyRecId === id);
                if (!isExist) {
                    return key;
                }
            })

            const flyersStatePayload: FlyersState = {...flyersState, flyers: [...newFlayerState]}
            dispatch({type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})
        } catch (err) {
            dispatch({
                type: ActionType.ARCHIVE_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const clearFlyersData = () => {
    return async (dispatch: Dispatch<ClearDataForFlyer>) => {
        dispatch({
            type: ActionType.SET_DEFAULT_STATE_FLYERS
        })
    }
}

export const updateSaleTypeForAccount = (saleTypes: SaleTypeDto[], requestData: UpdateSaleTypesObjectDto[]) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyersActions | SaleTypesActions>) => {
        dispatch({
            type: ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token,
                }
            }

            const request = {
                // accountId: userDto.userId,
                saleTypeIds: requestData
            };
            let url = `${envManager.flyerEditorServerAddress}/api/Account/UpdateAccountSaleType/${userDto.userId}`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_SUCCESS,
            })

            dispatch({
                type: ActionType.SET_SALE_TYPES_FOR_ALL_FLYERS,
                payload: saleTypes
            })

            dispatch({
                type: ActionType.SET_SALE_TYPES_FOR_SPECIFIC_FLYER,
                payload: saleTypes.filter((saleType: SaleTypeDto) => {
                    if (saleType.isAssignedToAccount) {
                        return saleType;
                    }
                }),
            })


            dispatch({type: ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_COMPLETE})

        } catch (err) {
            dispatch({
                type: ActionType.UPDATE_SALE_TYPES_FOR_ACCOUNT_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

